import { Role } from "../../helpers/role";

export const DistributorRoutes = [
  {
    name: "DRS_Distributor",
    path: `/${Role.Distributor}`,
    redirect: "/",
    component: () => import("@/layouts/Layout"),
    children: [
      {
        name: "Distributor_Home",
        path: "/",
        component: () => import("@/views/distributor/Home"),
        meta: {
          authorize: [Role.Distributor],
        },
      },

      {
        name: "Distributor_DealerList",
        path: "dealer-list",
        component: () => import("@/views/distributor/DealerList"),
        meta: {
          authorize: [Role.Distributor],
        },
      },

      {
        name: "Distributor_DealerPendingApproval",
        path: "distributor-dealer-pending-approval",
        component: () => import("@/views/distributor/DealerPendingApproval"),
        meta: {
          authorize: [Role.Distributor],
        },
      },

      {
        name: "Distributor_DealerDenied",
        path: "declined-dealer",
        component: () => import("@/views/distributor/DealerDenied"),
        meta: {
          authorize: [Role.Distributor],
        },
      },

      {
        name: "Distributor_DealerTopUpPending",
        path: "distributor-dealer-topUp-Pending",
        component: () =>
          import("@/views/distributor/DealerTopUpPendingApproval"),
        meta: {
          authorize: [Role.Distributor],
        },
      },

      {
        name: "Distributor_DealerTopUpHistory",
        path: "distributor-dealer-topUp-History",
        component: () => import("@/views/distributor/DealerTopUpHistory"),
        meta: {
          authorize: [Role.Distributor],
        },
      },

      {
        name: "Distributor_ServiceProviderRequestTopUp",
        path: "Distributor-serviceProvider-Request",
        component: () =>
          import("@/views/distributor/ServiceProviderRequestTopUp"),
        meta: {
          authorize: [Role.Distributor],
        },
      },
      {
        name: "Distributor_ServiceProviderPendingApproval",
        path: "Distributor-serviceProvider-Pending",
        component: () =>
          import("@/views/distributor/ServiceProviderPendingApproval"),
        meta: {
          authorize: [Role.Distributor],
        },
      },
      {
        name: "Distributor_ServiceProviderHistory",
        path: "Distributor-serviceProvider-History",
        component: () => import("@/views/distributor/ServiceProviderHistory"),
        meta: {
          authorize: [Role.Distributor],
        },
      },
      {
        name: "Distributor_RevenueRPT",
        path: "Distributor-RevenueRPT",
        component: () => import("@/views/distributor/DistributorReport"),
        meta: {
          authorize: [Role.Distributor],
        },
      },
      {
        name: "Distributor_ListAccount",
        path: "accounts",
        component: () => import("@/views/distributor/DistributorListAccount"),
        meta: {
          authorize: [Role.Distributor],
        },
      },
      {
        name: "Distributor_CreateAccount",
        path: "create-account",
        component: () => import("@/views/distributor/DistributorCreateAccount"),
        meta: {
          authorize: [Role.Distributor],
        },
      },

      {
        name: "Distributor_ListOfBanks",
        path: "list-of-banks",
        component: () => import("@/views/distributor/ListOfBanks"),
        meta: {
          authorize: [Role.Distributor],
        },
      },
    ],
  },
];
